import { KTIcon } from '@/_metronic/helpers';

type AnnouncementModalBandProps = {
  closable: boolean;
  closing: boolean;
  onClose: () => void;
};

/** Faixa do topo com o ícone do comunicado e, quando dá para fechar, o X. */
const AnnouncementModalBand = ({ closable, closing, onClose }: AnnouncementModalBandProps) => (
  <div className="announcement-modal-band position-relative d-flex align-items-center justify-content-center">
    <div className="announcement-modal-icon d-flex align-items-center justify-content-center">
      <KTIcon iconName="notification-on" />
    </div>
    {closable ? (
      <button
        aria-label="Fechar"
        className="btn-close position-absolute top-0 end-0 m-5"
        disabled={closing}
        type="button"
        onClick={onClose}
      />
    ) : null}
  </div>
);

export default AnnouncementModalBand;
